export default __webpack_public_path__ + "static/media/PSR1.7cec4cad.JPEG";